import React, { useState } from "react";
import Select from "react-select";
import ConfirmPopup from "../../../../myfin_v2/elements/ConfirmPopup";
import Modal from "../../../../myfin_v2/elements/Modal";
import { Button } from "../../../../myfin_v2/elements/Button";
import InputGroup from "../../../../myfin_v2/elements/InputGroup";
import CustomDropdownIndicator from "../../../../myfin_v2/elements/CustomDropdownIndicator";
import { ReactComponent as CloseGreyIcon } from "../../../../myfin_v2/assets/icons/close_grey.svg";
import commoncss from "../../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../../myfin_v2/css/button.module.css";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

const popupCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#f4faf5',
    borderColor: '#c2e6d1',
    color: '#b3c0bd',
    boxShadow: 'none',
    outline: 'none',
    borderWidth: '1px',
    borderRadius: '8px',
    '&:hover': {
      borderColor: '#c2e6d1',
    },
    minHeight: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0px 8px',
    display: 'flex',
    alignItems: 'center',
    height: '30px',
  }),
  input: (provided) => ({
    ...provided,
    color: '#205a46',
    margin: '0px',
    padding: '0px',
    fontSize: '12px',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    fontSize: '12px',
    marginTop: '0px',
    padding: '0px',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#205a46',
    fontSize: '12px',
    marginTop: '0px',
    padding: '0px',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '30px',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#1A4338',
    marginTop: '0px',
    padding: '4px',
    ':hover': {
      color: '#1A4338',
    },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      color: '#4f665f',
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#ffffff',
    border: '1px solid #c2e6d1',
    borderRadius: '4px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
    marginTop: '4px',
    zIndex: 9999,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '4px',
    borderRadius: '4px',
    maxHeight: '140px',
    overflowY: 'auto',
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    '::-webkit-scrollbar': {
      display: 'none',
    },
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected || state.isFocused ? '#f4faf5' : 'transparent',
    color: '#205a46',
    fontWeight: state.isSelected ? 500 : 300,
    padding: '6px 10px',
    cursor: 'pointer',
    ':active': {
      backgroundColor: '#f4faf5',
    },
    fontSize: '12px',
    borderRadius: '4px',
    marginBottom: '4px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left',
    ':last-child': {
      marginBottom: '0px',
    },
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    padding: '8px 12px',
  }),
};

const columnName = [
  { value: "parentTemplateID", label: "Parent Template Name" },
  { value: "name", label: "Template Name" },
  { value: "createdBy", label: "Created By" },
];

const type = [
  { value: "iscontains", label: "is contains" },
  { value: "empty", label: "is empty" },
];

export default function LibraryFilterModal({
  show,
  setFilterShow,
  state,
  setstate,
  handleApplyFilter,
  handleResetAll,
  defaultLibraryList
}) {
  const [showResetConfirm, setShowResetConfirm] = useState(false);

  const parentTemplateOptions = (defaultLibraryList || []).map((obj) => ({ label: obj.name, value: obj._id }));
  
  const uniqueCreators = [];
  const createdByOptions = [];
  (defaultLibraryList || []).forEach(obj => {
    if (obj.createdBy && !uniqueCreators.includes(obj.createdBy)) {
      uniqueCreators.push(obj.createdBy);
      createdByOptions.push({ label: obj.createdByName || "User", value: obj.createdBy });
    }
  });

  if (!show) return null;

  const handleFilter = () => {
    handleApplyFilter();
  };

  const handleChange = (field, i, e) => {
    let temp = [...state];
    if (field === "change") {
      temp[i][field] = e.target.value;
    } else {
      temp[i][field] = e.value;
      if (field === "select" && e.value === "empty") {
        temp[i]["change"] = "";
      }
    }
    setstate(temp);
  };

  function handleDelete(i) {
    const temp = [...state];
    let newarr;
    if (temp.length === 1) {
      newarr = [{ column: "", select: "", change: "" }];
    } else {
      newarr = temp.filter((val, ix) => ix !== i);
    }
    setstate(newarr);
    handleApplyFilter(newarr, false);
  }

  function handleNew() {
    setstate((oldArray) => [
      ...oldArray,
      { column: "", select: "", change: "" },
    ]);
  }

  const handleResetConfirmation = () => {
    setShowResetConfirm(true);
  };

  const confirmReset = () => {
    setShowResetConfirm(false);
    handleResetAll();
  };

  return (
    <>
      <style>{`
        .select__menu-list {
            -ms-overflow-style: none;
            scrollbar-width: none;
        }
        .select__menu-list::-webkit-scrollbar {
            display: none !important;
        }
      `}</style>
      <Modal
        width={`38%`}
        minHeight={"350px"}
        title="Custom Filters"
        headerActions={
          <>
            <label
              className={`${commoncss.textLabel} ${commoncss.fs15} ${commoncss.clickable}`}
              onClick={handleResetConfirmation}
            >
              Reset All
            </label>
          </>
        }
        onClose={() => setFilterShow(false)}
        footerActions={
          <>
            <Button
              btnColor={buttoncss.secondary}
              onClick={() => {
                setFilterShow(false);
              }}
              label="Cancel"
            />
            <span>
              <Button
                btnColor={buttoncss.secondary}
                label="Add Filter"
                onClick={() => {
                  handleNew();
                }}
              />
              &ensp;
              <Button
                btnColor={buttoncss.primary}
                label="Apply Filter"
                onClick={handleFilter}
              />
            </span>
          </>
        }
      >
        {state.length === 0 && (
           <div style={{ textAlign: "center", marginTop: "20px", color: "#809790" }}>
             Filter data is empty. Click 'Add Filter' to add conditions.
           </div>
        )}
        {state.map((val, i) => {
          return (
            <React.Fragment key={i}>
              <span className="input-label mt-1">&nbsp;Where</span>
              <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "10px" }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <Select
                    placeholder="Select Field"
                    value={columnName.filter(function (option) {
                      return option.value === val.column;
                    })}
                    options={columnName}
                    onChange={(e) => handleChange("column", i, e)}
                    className="w-100 mt-0"
                    classNamePrefix="select"
                    components={{
                      ...animatedComponents,
                      IndicatorSeparator: () => null,
                      DropdownIndicator: CustomDropdownIndicator,
                    }}
                    styles={popupCustomStyles}
                    menuPortalTarget={document.body}
                  />
                </div>

                <div style={{ flex: 1, minWidth: 0 }}>
                  <Select
                    placeholder="Select Type"
                    value={type.filter(function (option) {
                      return option.value === val.select;
                    })}
                    options={type}
                    onChange={(e) => handleChange("select", i, e)}
                    className="w-100 mt-0"
                    classNamePrefix="select"
                    components={{
                      ...animatedComponents,
                      IndicatorSeparator: () => null,
                      DropdownIndicator: CustomDropdownIndicator,
                    }}
                    styles={popupCustomStyles}
                    menuPortalTarget={document.body}
                  />
                </div>

                <div style={{ flex: 1, minWidth: 0 }}>
                  {val.column === "parentTemplateID" ? (
                    <Select
                      placeholder="Select value"
                      value={parentTemplateOptions.find(o => o.value === val.change) || null}
                      options={parentTemplateOptions}
                      onChange={(e) => handleChange("change", i, { target: { value: e ? e.value : "" } })}
                      isDisabled={val.select === "empty"}
                      className="w-100 mt-0"
                      classNamePrefix="select"
                      components={{
                        ...animatedComponents,
                        IndicatorSeparator: () => null,
                        DropdownIndicator: CustomDropdownIndicator,
                      }}
                      styles={popupCustomStyles}
                      menuPortalTarget={document.body}
                    />
                  ) : (
                    <InputGroup
                      inputs={[
                        <input
                          style={{
                            height: "32px",
                            padding: "0 10px",
                            fontSize: "12px",
                            border: "1px solid #c2e6d1",
                            backgroundColor: "#f4faf5",
                            borderRadius: "8px",
                            color: "#205a46",
                            boxSizing: "border-box",
                            width: "100%",
                            textAlign: "left",
                            outline: "none",
                          }}
                          placeholder="Enter value"
                          value={val.change}
                          disabled={val.select === "empty"}
                          onChange={(e) => handleChange("change", i, e)}
                        />,
                      ]}
                    />
                  )}
                </div>
                <button
                  type="button"
                  onClick={() => {
                    handleDelete(i);
                  }}
                  style={{
                    background: "transparent",
                    border: "none",
                    fontSize: "1.2rem",
                    cursor: "pointer",
                  }}
                  title="Remove filter"
                >
                  <CloseGreyIcon />
                </button>
              </div>
            </React.Fragment>
          );
        })}
      </Modal>
      
      <ConfirmPopup 
        isOpen={showResetConfirm}
        title="Confirm Reset"
        message="Are you sure you want to reset all filters?"
        confirmText="Reset"
        onConfirm={confirmReset}
        onCancel={() => setShowResetConfirm(false)}
      />
    </>
  );
}
